<hash-value/files = [{ 
  name:"index.marko", 
  path:"/components/index.marko", 
  content:"<let/count=0/>\n<button onClick() { count++ }>\n  ${count}\n</button>"
}]/>
<repl files:=files/>